import { combineReducers } from 'redux';
import { PersistedState, persistReducer } from 'redux-persist';

import { authReducer } from './auth/reducers';
import { usersReducer } from './users/reducers';
import { languagesReducer } from './languages/reducers';
import { missionsReducer } from './missions/reducers';
import { additionalStagesReducer } from './additionalStages/reducers';
import { exercisesReducer } from './exercises/reducers';
import { additionalExercisesReducer } from './additionalExercises/reducers';
import { tasksReducer } from './tasks/reducers';
import { rewardsReducer } from './rewards/reducers';
import { taskTypesReducer } from './taskTypes/reducers';
import { documentsReducer } from './documents/reducers';
import { coachReducer } from './coach/reducers';
import { meetingsReducer } from './meetings/reducers';
import { chatScheduleReducer } from './chatSchedule/reducers';
import storage from 'redux-persist/lib/storage';

const userPersistConfig = {
    key: 'user',
    storage,
    whitelist: ['users'],
};

const rootReducer = combineReducers({
    authReducer,
    usersReducer: persistReducer(userPersistConfig, usersReducer),
    languagesReducer,
    missionsReducer,
    additionalStagesReducer,
    exercisesReducer,
    tasksReducer,
    rewardsReducer,
    additionalExercisesReducer,
    taskTypesReducer,
    documentsReducer,
    coachReducer,
    meetingsReducer,
    chatScheduleReducer,
});

export type AppState = ReturnType<typeof rootReducer> & PersistedState;

export default rootReducer;
